document.documentElement.classList.add('js');

const REVEAL_Y = 24;
const REVEAL_DURATION = 0.55;
const REVEAL_STAGGER = 0.12;

function prefersReducedMotion() {
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function markRevealed(el) {
	el.classList.add('is-revealed');
	el.dispatchEvent(new CustomEvent('reveal:complete', { bubbles: true }));
}

function showImmediately(els) {
	els.forEach(function (el) {
		el.style.opacity = '1';
		el.style.transform = 'none';
		markRevealed(el);
	});
}

function isInactivePanelEl(el) {
	return Boolean(
		el.closest('[hidden]') ||
		el.closest('.hero__panel:not(.is-active)') ||
		el.closest('.contact-embed__tab-content:not(.active)')
	);
}

function collectTwoColumnItems(root) {
	const items = [];
	const seen = new Set();

	function push(el) {
		if (el && !seen.has(el)) {
			seen.add(el);
			items.push(el);
		}
	}

	root.querySelectorAll('.two-column__intro > [data-reveal-el]').forEach(push);

	const wrapper = root.querySelector('.two-column__wrapper');
	if (!wrapper) {
		return items;
	}

	const columns = Array.from(wrapper.querySelectorAll(':scope > .two-column__item'));
	const hasImage = columns.some(function (col) {
		return col.querySelector('.two-column__image');
	});
	const hasText = columns.some(function (col) {
		return col.querySelector('.two-column__content');
	});

	if (hasImage && hasText) {
		columns.forEach(function (col) {
			push(col.querySelector('.two-column__image'));
		});
		columns.forEach(function (col) {
			const content = col.querySelector('.two-column__content');
			if (content) {
				content.classList.add('is-revealed');
				content.style.opacity = '1';
				content.style.transform = 'none';
				content.querySelectorAll(':scope > *').forEach(push);
			}
			push(col.querySelector('.two-column__button'));
			col.querySelectorAll('.two-column__icon-item').forEach(push);
		});
		return items;
	}

	columns.forEach(function (col) {
		col.querySelectorAll('[data-reveal-el]').forEach(push);
	});

	return items;
}

function collectRevealItems(root) {
	if (root.querySelector('.two-column__wrapper')) {
		return collectTwoColumnItems(root);
	}

	return Array.from(root.querySelectorAll('[data-reveal-el]'))
		.filter(function (el) {
			return !isInactivePanelEl(el);
		})
		.sort(function (a, b) {
			const ao = parseFloat(a.getAttribute('data-reveal-order') || '');
			const bo = parseFloat(b.getAttribute('data-reveal-order') || '');
			const aOrder = Number.isNaN(ao) ? 0 : ao;
			const bOrder = Number.isNaN(bo) ? 0 : bo;
			if (aOrder !== bOrder) {
				return aOrder - bOrder;
			}
			return 0;
		});
}

function initReveals() {
	const roots = document.querySelectorAll('[data-reveal]');
	if (!roots.length) {
		return;
	}

	const gsap = window.gsap;
	const ScrollTrigger = window.ScrollTrigger;
	const reduceMotion = prefersReducedMotion();

	roots.forEach(function (root) {
		root.querySelectorAll('[data-reveal-el]').forEach(function (el) {
			if (isInactivePanelEl(el)) {
				el.classList.add('is-revealed');
				el.style.opacity = '';
				el.style.transform = '';
			}
		});

		const items = collectRevealItems(root);
		if (!items.length) {
			return;
		}

		if (reduceMotion || !gsap || !ScrollTrigger) {
			showImmediately(items);
			return;
		}

		gsap.registerPlugin(ScrollTrigger);
		gsap.set(items, { opacity: 0, y: REVEAL_Y });

		gsap.to(items, {
			opacity: 1,
			y: 0,
			duration: REVEAL_DURATION,
			ease: 'power2.out',
			overwrite: 'auto',
			stagger: {
				each: REVEAL_STAGGER,
				onComplete: function () {
					const target = this.targets && this.targets()[0];
					if (target) {
						markRevealed(target);
					}
				},
			},
			onComplete: function () {
				items.forEach(function (el) {
					if (!el.classList.contains('is-revealed')) {
						markRevealed(el);
					}
				});
			},
			scrollTrigger: {
				trigger: root,
				start: 'top 80%',
				toggleActions: 'play none none none',
				once: true,
			},
		});
	});
}

function boot() {
	initReveals();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', boot);
} else {
	boot();
}
